export const getFileExt = fileName =>
  fileName.indexOf(".")
    ? fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
    : null;